import { TrackJS } from 'trackjs';
import { HORIZON_ENABLED } from '#/rendering/state/renderingState';

export function configureTrackJs(userId: string | null | undefined) {
  if (TrackJS.isInstalled()) {
    if (userId) {
      TrackJS.configure({
        userId,
      });
    }
    const applicationContext = window.navigator.userAgent.includes(
      'Idealist Mobile App iOS',
    )
      ? 'ios'
      : 'web';
    TrackJS.addMetadata('applicationContext', applicationContext);
    TrackJS.addMetadata('ssrServer', HORIZON_ENABLED ? 'horizon' : 'hypernova');
  }
}
